// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TableProfessional_container__hwZFo {
    font-family: Arial, sans-serif;
    padding: 20px;
  }
  
  .TableProfessional_table__10ZPM {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }
  
  .TableProfessional_table__10ZPM th,
  .TableProfessional_table__10ZPM td {
    border: 1px solid #8ca7a6;
    padding: 10px;
    text-align: center;
  }
  .TableProfessional_table__10ZPM th {
    background-color: #8ca7a6;
    color: white;

  }
  .TableProfessional_button__Nz0wN {
    padding: 5px 10px;
    background-color: red;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 5px;
  }
  
  .TableProfessional_button__Nz0wN:hover {
    background-color: darkred;
  }
  
  .TableProfessional_modal__GWYHm {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .TableProfessional_modalContent__ApLLy {
    background-color: white;
    padding: 20px;
    border-radius: 5px;
    text-align: center;
  }
  
  .TableProfessional_confirmButton__KnuRv {
    padding: 10px 20px;
    background-color: green;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 5px;
    margin-right: 10px;
  }
  
  .TableProfessional_cancelButton__XUkOK {
    padding: 10px 20px;
    background-color: gray;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 5px;
  }
  
  .TableProfessional_confirmButton__KnuRv:hover {
    background-color: darkgreen;
  }
  
  .TableProfessional_cancelButton__XUkOK:hover {
    background-color: darkgray;
  }
  
  .TableProfessional_viewInformation__nA3VG {
    text-decoration: underline;
    cursor: pointer;
    transition: color 0.5s ease;
  }

  .TableProfessional_viewInformation__nA3VG:hover {
  color: #8ca7a6;
  }`, "",{"version":3,"sources":["webpack://./src/styles/PanelAdmin/TableProfessional.module.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,aAAa;EACf;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;;IAEE,yBAAyB;IACzB,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,YAAY;;EAEd;EACA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,eAAe;IACf,2BAA2B;EAC7B;;EAEA;EACA,cAAc;EACd","sourcesContent":[".container {\n    font-family: Arial, sans-serif;\n    padding: 20px;\n  }\n  \n  .table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 20px;\n  }\n  \n  .table th,\n  .table td {\n    border: 1px solid #8ca7a6;\n    padding: 10px;\n    text-align: center;\n  }\n  .table th {\n    background-color: #8ca7a6;\n    color: white;\n\n  }\n  .button {\n    padding: 5px 10px;\n    background-color: red;\n    color: white;\n    border: none;\n    cursor: pointer;\n    border-radius: 5px;\n  }\n  \n  .button:hover {\n    background-color: darkred;\n  }\n  \n  .modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .modalContent {\n    background-color: white;\n    padding: 20px;\n    border-radius: 5px;\n    text-align: center;\n  }\n  \n  .confirmButton {\n    padding: 10px 20px;\n    background-color: green;\n    color: white;\n    border: none;\n    cursor: pointer;\n    border-radius: 5px;\n    margin-right: 10px;\n  }\n  \n  .cancelButton {\n    padding: 10px 20px;\n    background-color: gray;\n    color: white;\n    border: none;\n    cursor: pointer;\n    border-radius: 5px;\n  }\n  \n  .confirmButton:hover {\n    background-color: darkgreen;\n  }\n  \n  .cancelButton:hover {\n    background-color: darkgray;\n  }\n  \n  .viewInformation {\n    text-decoration: underline;\n    cursor: pointer;\n    transition: color 0.5s ease;\n  }\n\n  .viewInformation:hover {\n  color: #8ca7a6;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TableProfessional_container__hwZFo`,
	"table": `TableProfessional_table__10ZPM`,
	"button": `TableProfessional_button__Nz0wN`,
	"modal": `TableProfessional_modal__GWYHm`,
	"modalContent": `TableProfessional_modalContent__ApLLy`,
	"confirmButton": `TableProfessional_confirmButton__KnuRv`,
	"cancelButton": `TableProfessional_cancelButton__XUkOK`,
	"viewInformation": `TableProfessional_viewInformation__nA3VG`
};
export default ___CSS_LOADER_EXPORT___;
